import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/About.css";

function About() {
  return (
    <>
      
      <Navbar />

      <div className="about-container">

        <h1>About US</h1>

        <p>
          <strong>Bomander Travel Agency</strong> is a trusted and professional travel and visa consultancy
          dedicated to making international travel simple, accessible, and stress-free.
        </p>

        <p>
          We provide end-to-end support for travel services, ensuring smooth journeys from application to arrival.
        </p>

        <hr />

        <h2>Who We Are</h2>
        <ul>
          <li>Visa application processing</li>
          <li>University admission support</li>
          <li>International travel guidance</li>
        </ul>

        <hr />

        <h2>What We Do</h2>
        <ul>
          <li>Tourism & Visitor Visas</li>
          <li>Study Visa Processing</li>
          <li>Work Sponsorship Support</li>
          <li>Conference Applications</li>
        </ul>

        <hr />

        <h2>Our Mission</h2>
        <p>
          To connect people to global opportunities through reliable and efficient travel services.
        </p>

        <hr />

        <h2>Our Vision</h2>
        <p>
          To become a leading travel agency known for trust and high success rates.
        </p>

        <hr />

        <h2> Why Choose Us?</h2>
        <ul>
          <li>Experienced consultants</li>
          <li>High success rate</li>
          <li>Transparent guidance</li>
          <li>Fast processing</li>
        </ul>

        <h3>
          <em>Turning your travel dreams into reality.</em>
        </h3>

      </div>

      
      <Footer />
    </>
  );
}

export default About;
